import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'neoris-confirm-dialog-alerts',
  templateUrl: './confirm-dialog-alerts.component.html',
  styleUrl: './confirm-dialog-alerts.component.css'
})
export class ConfirmDialogAlertsComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmDialogAlertsComponent>){

  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
